import React from 'react';
import { GridTextField } from './shared';

const FormTextField = ({ fullWidth, size, md, ...rest }) => {
  return (
    <GridTextField
      xs={fullWidth ? 12 : size}
      md={md ? md : fullWidth ? 12 : size}
      fullWidth
      {...rest}
    />
  );
};

FormTextField.defaultProps = {
  size: 6,
};

export default FormTextField;
